import { useState } from "react";
import { Reveal } from "@/components/site/Reveal";
import { SectionLabel, AudienceToggle, InternetCards, SubpageBanner } from "@/components/att/ATTShared";

export default function ATTInternetPage() {
  const [tab, setTab] = useState("residential");
  return (
    <div className="py-14 md:py-20" data-testid="att-internet-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-10">
        <Reveal>
          <SubpageBanner src="/att/og-internet.jpg" alt="AT&T Fiber internet" testid="att-internet-banner" />
        </Reveal>
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-5">
            <div>
              <SectionLabel>Internet Services</SectionLabel>
              <h1 className="mt-4 font-serif-display text-4xl sm:text-5xl font-bold tracking-tight text-[#1d2329]">Internet &amp; fiber pricing.</h1>
            </div>
            <AudienceToggle value={tab} onChange={setTab} />
          </div>
        </Reveal>
        <InternetCards audience={tab} />
      </div>
    </div>
  );
}
